import { graphql as gatsbyGraphQL, useStaticQuery } from 'gatsby';

export default function useSiteConfig() {
  const siteConfig = useStaticQuery(query);
  return afterQuery(siteConfig);
}

export const query = gatsbyGraphQL/* GraphQL */ `
  query SiteConfig {
    site {
      siteMetadata {
        tastingNotesEnabled
        listsEnabled
        showDistributionDetails
      }
    }
  }
`;

function afterQuery({ site }) {
  return {
    tastingNotesEnabled: Boolean(site?.siteMetadata?.tastingNotesEnabled),
    listsEnabled: Boolean(site?.siteMetadata?.listsEnabled),
    /** @type {'inMarket' | 'global' | 'all' | 'none'} */
    showDistributionDetails:
      site?.siteMetadata?.showDistributionDetails || 'inMarket',
    myListDataUri:
      // Where my list loads data from.
      process.env.GATSBY_MY_LIST_DATA_URI ||
      'https://api.bottlebooks.me/graphql',
    bottlebooksApiRoot:
      process.env.BOTTLEBOOKS_API_ROOT || 'https://app.bottlebooks.me',
    isChatEnabled: process.env.GATSBY_CHAT_ENABLED === 'true',
    isMeetingBookingEnabled:
      process.env.GATSBY_MEETING_BOOKING_ENABLED === 'true',
  };
}
